const hostToPath: Partial<Record<string, string>> = {
	"127.0.0.1:5002": "",
	"internal.de-dev.devde-rancher.ist.com": "/connect-gui",
	"localhost:5002": "",
} as const;

export const apiUrl: string = hostToPath[window.location.host] || "";
